import {useContext, useState} from "react";
import {apartmentSearchAPI} from "../common/api/apartmentSearchAPI";
import {API_APARTMENT_SEARCH_CHEAPEST_APARTMENT_PRICE} from "../common/api/apiConstants";
import {createURLQuery} from "../common/api/apiUtil";
import {CurrencyContext} from "../store/providers/CurrencyProvider";
import {LocaleContext} from "../store/providers/LocaleProvider";

export const useCheapestApartmentPrice = () => {

    const [currencyState] = useContext(CurrencyContext);
    const {localeUppercaseUnderscore} = useContext(LocaleContext)[0];
    const [cheapestApartmentPrice, setCheapestApartmentPrice] = useState({priceLoaded: false});
    const [priceLoading, setPriceLoading] = useState(false);
    const [error, setError] = useState(null);

    const loadCheapestApartmentPrice = (params, forceLoad) => {
        if (!priceLoading
            && (!cheapestApartmentPrice.priceLoaded || forceLoad)
            && params?.resort_id
            && params?.date_from
            && params?.date_to
            && params?.number_of_guests
            && currencyState?.currency
        ) {

            setPriceLoading(true);
            setError(null);

            let parameters = {
                resort_id: params?.resort_id,
                date_from: params?.date_from,
                date_to: params?.date_to,
                number_of_guests: params?.number_of_guests,
                wheelchair_accessible: Boolean(params?.wheelchair_accessible) || "false",
                currency: currencyState.currency,
                locale: localeUppercaseUnderscore,
            };

            if (params?.flexible_dates) {
                parameters.duration = params.flexible_dates;
            }

            if(params?.trial) {
                parameters.trial = params.trial;
            }

            apartmentSearchAPI.get(API_APARTMENT_SEARCH_CHEAPEST_APARTMENT_PRICE + createURLQuery(parameters))
                .then(res => res.data)
                .then(response => {
                    setCheapestApartmentPrice({...response, ...{priceLoaded: true}});
                    setPriceLoading(false);
                })
                .catch(err => {
                    setCheapestApartmentPrice({priceLoaded: true});
                    setPriceLoading(false);
                    setError(err);
                });
        }
    };

    return {
        cheapestApartmentPrice,
        loadCheapestApartmentPrice,
        priceLoading,
        error
    };
};
